<header class="top-nav"
        data-testid="header-container">
  <div class="spacer"></div>
  <online-indicator data-testid="header-online-indicator"></online-indicator>
</header>
